import T from 'prop-types';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { createShouldForwardProp } from '../../helpers/createShouldForwardProp';
import { createPropTypes, system } from '../../styles/system';
import { unit } from '../../styles/unit';
import { jsx as _jsx } from "react/jsx-runtime";
const alignmentsX = {
  leading: 'flex-start',
  trailing: 'flex-end',
  center: 'center',
  spread: 'space-between'
};
const alignmentsY = {
  top: 'flex-start',
  bottom: 'flex-end',
  center: 'center',
  stretch: 'stretch'
};
const stackStyle = system({
  alignX: value => {
    if (!value) return;
    const justifyContent = alignmentsX[value];
    return {
      justifyContent
    };
  },
  alignY: value => {
    if (!value) return;
    const alignItems = alignmentsY[value];
    return {
      alignItems
    };
  },
  wrap: {
    property: 'flexWrap',
    transform: value => value ? 'wrap' : 'nowrap'
  },
  gap: value => {
    if (!value) return null;
    return {
      margin: unit(value / -2),
      '&& > *': {
        margin: unit(value / 2)
      }
    };
  }
});
const styleProps = stackStyle.withDefaults({
  wrap: false,
  alignX: 'leading',
  alignY: 'top'
});
const shouldForwardProp = createShouldForwardProp(styleProps.propNames);
const StyledHStack = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp
})({
  display: 'flex',
  alignContent: 'flex-start'
}, styleProps);
const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "Container",
  componentId: "th1hpm-0"
})(["min-width:0;"]);
const HStack = /*#__PURE__*/forwardRef(function HStack(props, forwardedRef) {
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(StyledHStack, Object.assign({
      ref: forwardedRef
    }, props))
  });
});
HStack.propTypes = Object.assign({}, createPropTypes(styleProps.propNames), {
  wrap: T.bool,
  alignX: T.oneOf(Object.keys(alignmentsX)),
  alignY: T.oneOf(Object.keys(alignmentsY))
});
export { HStack };